export default __webpack_public_path__ + "static/media/project_img_3.e36b2bee.jpeg";